import script from "./OperationWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationWizard.vue?vue&type=script&setup=true&lang=js"

import "./OperationWizard.vue?vue&type=style&index=0&id=827c98ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-827c98ca"]])

export default __exports__